<template>
    <div id='embargo'  v-if="alertShow">
        <div class="box1" v-if="step==1">
            <div class="content">
                <div class="p">如何在包裝上慳運費 ?</div>
                <h2 class="h">運費計算方法</h2>
                <div class="section">
                    <div class="item">
                        <div class="img">
                            <img src="./img/bear.png" alt="箱子熊">
                        </div>
                        <div class="info">
                            <p class="h">毛公仔 (連包裝)</p>
                            <div class="middle">
                                <div class="row">
                                    <p>實際重量</p>
                                    <p>郵件體積重量</p>
                                </div>
                                <div class="row">
                                    <h2 class="weight">3.0 KG</h2>
                                    <div class="lessThen">
                                        <span class="el-icon-arrow-left"></span>
                                    </div>
                                    <h2 class="weight activeWeight">6.0 KG</h2>
                                </div>
                                <div class="bottom">
                                    <div class="tips">以此重量收費</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="img">
                            <img src="./img/book.png" alt="箱子熊">
                        </div>
                        <div class="info">
                            <p class="h">毛公仔 (連包裝)</p>
                            <div class="middle">
                                <div class="row">
                                    <p>實際重量</p>
                                    <p>郵件體積重量</p>
                                </div>
                                <div class="row">
                                    <h2 class="weight activeWeight">6.0 KG</h2>
                                    <div class="lessThen">
                                        <span class="el-icon-arrow-left"></span>
                                    </div>
                                    <h2 class="weight">3.0 KG</h2>
                                </div>
                                <div class="bottom">
                                    <div class="tips">以此重量收費</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="btns">
                    <div class="on">
                        <optionsButton title="下一頁" :callback="next"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="box2" v-if="step==2">
            <div class="content">
                <div class="p">甚麼是郵件體積重量 ?</div>
                <h2 class="h">運費計算方法</h2>
                <div class="section">
                    <div class="item">
                        <div class="img">
                            <img src="./img/bear.png" alt="箱子熊">
                        </div>
                        <div class="info">
                            <p class="h">體積重量</p>
                            <div class="middle">
                                <div class="row border-bottom">
                                    <span>長度cm x 闊度cm x 高度cm</span>
                                </div>
                                <div class="row">
                                    <span>5000</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <p>體積重量是快遞公司根據貨物在飛機上所佔的空間進行收費。
                    運費以體積重量 或 實際重量的價高者來計算。
                    </p>
                <div class="btns">
                    <div class="on">
                        <optionsButton title="知道了" :callback="shut"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import optionsButton from '@/components/optionButton'
export default {
    name:'Embargo',
    props:["title","text","callback","alertShow",'p'],
    components:{
        optionsButton
    },
    data(){
        return {
            step:1
        }
    },
    methods: {
        // 下一步
        next(){
            this.step = 2
        },
        // 关闭
        shut(){
            this.step = 1
            this.callback()
        }
    },
}
</script>

<style lang="less">
    #embargo{
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        text-align: center;
        background-color: #656565;
        z-index: 9999;
        .box1,.box2{
            display: flex;
            height: 100%;
            justify-content: center;
            align-items: center;
            animation: show .5s;
            .content{
                width: 600px;
                height: 600px;
                border-radius: 20px;
                background-color: #fff;
                text-align: center;
                padding:0 80px ;
                .p{
                    margin-top:10%;
                    color: @colorMain;
                    font-size:23px;
                    margin-bottom:3%;
                }
                .h{
                    text-align:center;
                    color: @colorMain;
                    font-size:30px;
                    margin-bottom:0px;
                }
                .section{
                    display: flex;
                    margin-top: 60px;
                    justify-content: center;
                    flex-wrap: wrap;
                    .item{
                        display: flex;
                        align-items:center;
                        width: 393px;
                        height: 135px;
                        background-color:#F2F2F2;
                        border-radius:10px;
                        margin-bottom:20px;
                        .img{
                            margin-left: -40px;
                            img{
                                width: 125px;
                                height: 109px;
                            }
                        }
                        .info{
                            display: flex;
                            flex-wrap: wrap;
                            width: 60%;
                            height: 100%;
                            margin-left: 30px;
                            .h{
                                text-align:center;
                                color: @colorMain;
                                font-size:13px;
                                width: 100%;
                                margin-top:5px;
                            }
                            .middle{
                                flex-wrap: wrap;
                                width: 100%;
                                margin-top: -15px;
                                .row{
                                    display: flex;
                                    align-items:center;
                                    width: 100%;
                                }
                                .row{
                                    display: flex;
                                    justify-content: space-between;
                                    p{
                                        margin: 0;
                                        font-size:13px;
                                        font-weight:550;
                                    }
                                    .weight{
                                        font-size: 23px;
                                        font-weight: 600;
                                        font-family: "Source Han Sans HK";
                                    }
                                    .activeWeight{
                                        color: @colorMain;
                                    }
                                }
                                .row.border-bottom{
                                    border-bottom: 2px solid #ccc ;
                                    padding-bottom: 10px;
                                }
                                .bottom{
                                    display: flex;
                                    width: 100%;
                                    justify-content: flex-end;
                                    margin-top: 10px;
                                    .tips{
                                        width: 101px;
                                        border-radius: 10px;
                                        color: #fff;
                                        background: #737cbe;
                                        font-size: 13px;
                                        height: 21px;
                                        line-height: 21px;
                                        margin: 0;
                                        margin-right: -10px;
                                    }
                                }
                                .lessThen{
                                    display: flex;
                                    justify-content: space-between;
                                    align-items: center;
                                    font-size: 30px;
                                    font-weight: 600;
                                    height: 100%;
                                }
                            }
                        }
                    }
                    .item:last-child{
                        .info{
                            .bottom{
                                justify-content: flex-start;
                            }
                        }
                    }
                }
                p{
                    font-size: 17px;
                    font-weight: 580;
                    text-align:center;
                    line-height: 30px;
                    font-weight: 600;
                }
                .btns{
                    margin-top: 20px;
                    text-align: center;
                }
            }
        }
        .box2 .content .section .item .info .middle .row{
            justify-content: center;
            margin-bottom: 10px;
            font-weight: 600;
            font-size: 17px;
        }
        .box2 .content  {
            .btns{
                    margin-top: 100px !important;
                }
        }
        .box2 .content .section .item .info .middle .row:last-child{
            margin-bottom: 0px;
        }
    }
</style>